import { TextField, TextFieldProps } from "@mui/material";
import React, { useState } from "react";
import { InputCounter } from "./inputCounter";

type ITextFieldWithInputCounterProps = TextFieldProps & {
    inputDivStyle?: React.CSSProperties;
    maxCount: number;
    value: string;
}

const TextFieldWithInputCounter: React.FC<ITextFieldWithInputCounterProps> = ({
    inputDivStyle,
    variant,
    multiline,
    value,
    onChange,
    inputProps,
    style,
    size,
    error,
    InputProps,
    maxCount
}) => {
    const [isFocused, setIsFocused] = useState<boolean>(false);
    
    return <div style={inputDivStyle}>
        <TextField
            variant={variant}
            multiline={multiline}
            fullWidth
            value={value}
            onChange={onChange}
            inputProps={{
                maxLength: maxCount,
                ...inputProps
            }}
            style={style}
            InputProps={InputProps}
            size={size}
            error={error}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
        />
        <InputCounter
            count={value?.length || 0}
            maxCount={maxCount}
            isFocused={isFocused}
        />
    </div>;
};

export default TextFieldWithInputCounter;
